import type { SalonSlug } from "./types";

export interface Review {
  id: string;
  author: string;
  location: string;
  rating: number;
  text: string;
  salonSlug: SalonSlug;
  date: string;
  source: "Google" | "BokaDirekt";
  verified: boolean;
  service?: "taper-fade" | "herrklippning" | "skägg" | "hår-skägg" | "barnklippning";
}

export const reviews: Review[] = [
  // ─── Senaste recensionerna (BokaDirekt, aug 2026) ───────────────────────
  {
    id: "r112",
    author: "Thomas A.",
    location: "Stockholm",
    rating: 5,
    text: "Jag är novis i skäggodling. Fick en föredömlig genomgång med bra tips och många goda råd kring skäggvården. Kände mig som en ny människa när jag gick därifrån. Stort tack till Nick som lärde mig mycket på bara en halvtimme. Utmärkt hantverk.",
    salonSlug: "ahlens-city",
    date: "2026-08-21",
    source: "BokaDirekt",
    verified: true,
    service: "skägg",
  },
  {
    id: "r113",
    author: "Therese N.",
    location: "Täby",
    rating: 5,
    text: "Jättebra frisör som kom med bra ideer kring den nya frisyren till en 10-åring. Han gick därifrån jättenöjd. Tack!",
    salonSlug: "taby",
    date: "2026-08-17",
    source: "BokaDirekt",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r114",
    author: "Hanna S.",
    location: "Åkersberga",
    rating: 5,
    text: "Tony klipper med en otrolig värme och precision. Vi är alltid lika nöjda och han ger alltid det lilla extra.",
    salonSlug: "akersberga",
    date: "2026-08-16",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r115",
    author: "David C.",
    location: "Arninge",
    rating: 5,
    text: "Bra klippning och vänliga personal, väldigt relaxed atmosfär.",
    salonSlug: "arninge",
    date: "2026-08-12",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r101",
    author: "Jesper E.",
    location: "Täby",
    rating: 5,
    text: "Väldigt nöjd, barberaren förstod precis vad jag ville ha och kom även med egna inputs, mycket nöjd!",
    salonSlug: "taby",
    date: "2026-08-10",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r102",
    author: "Helena P.",
    location: "Täby",
    rating: 5,
    text: "Första gången här, bytte frisörställe och sonen är väldigt nöjd.",
    salonSlug: "taby",
    date: "2026-08-10",
    source: "BokaDirekt",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r103",
    author: "Hampus S.",
    location: "Täby",
    rating: 4,
    text: "Skön vibe och bra snack – det blev aldrig stelt.",
    salonSlug: "taby",
    date: "2026-08-11",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r104",
    author: "Thimmy S.",
    location: "Stockholm",
    rating: 5,
    text: "Kan starkt rekommendera Tara, kunnig och trevlig!",
    salonSlug: "ahlens-city",
    date: "2026-08-11",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r105",
    author: "Elvis G.",
    location: "Stockholm",
    rating: 5,
    text: "Riktigt nöjd med klippningen som vanligt!",
    salonSlug: "ahlens-city",
    date: "2026-08-07",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r106",
    author: "Matilda R.",
    location: "Åkersberga",
    rating: 5,
    text: "Diana är alltid bäst.",
    salonSlug: "akersberga",
    date: "2026-08-10",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r107",
    author: "Patrik C.",
    location: "Åkersberga",
    rating: 5,
    text: "Alltid nöjd. Alltid trevlig och glad. Vi ses snart igen!",
    salonSlug: "akersberga",
    date: "2026-08-06",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r108",
    author: "Luke C.",
    location: "Åkersberga",
    rating: 5,
    text: "Noggrann och bra klippning.",
    salonSlug: "akersberga",
    date: "2026-08-05",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r109",
    author: "Amin M.",
    location: "Arninge",
    rating: 5,
    text: "Vahid är bäst! Man går alltid därifrån supernöjd – snyggt, stilrent och riktigt bra gjort.",
    salonSlug: "arninge",
    date: "2026-08-08",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r110",
    author: "Kimmo H.",
    location: "Arninge",
    rating: 5,
    text: "William är mycket bra på alla sätt. Han lyssnar på dina önskemål och jobbar fram till det jag önskade.",
    salonSlug: "arninge",
    date: "2026-08-08",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r111",
    author: "Mikael A.",
    location: "Arninge",
    rating: 4,
    text: "Trevlig och bra service.",
    salonSlug: "arninge",
    date: "2026-08-12",
    source: "BokaDirekt",
    verified: true,
  },
  // ─── Åhléns City ────────────────────────────────────────────────────────

  {
    id: "r1",
    author: "Marcus L.",
    location: "Stockholm",
    rating: 5,
    text: "Bästa barberaren i stan – punkt slut. Kom in utan bokning på lunchen och blev servad direkt. Skin fade som sitter perfekt, barberaren lyssnade noga på vad jag ville ha. Kommer tillbaka varannan vecka.",
    salonSlug: "ahlens-city",
    date: "2026-06-18",
    source: "Google",
    verified: true,
    service: "taper-fade",
  },
  {
    id: "r2",
    author: "Jonas E.",
    location: "Vasastan",
    rating: 5,
    text: "Fantastisk service. Har provat många ställen i Stockholm men Tailor's slår dem alla. Skäggtrimningen blev precis som jag ville – väldefinierad och naturlig. Proffsen vet verkligen vad de gör.",
    salonSlug: "ahlens-city",
    date: "2026-06-29",
    source: "Google",
    verified: true,
    service: "skägg",
  },
  {
    id: "r3",
    author: "Daniel W.",
    location: "Södermalm",
    rating: 5,
    text: "Gick hit första gången efter ett tips från en kollega. Ska aldrig gå någon annanstans igen. Taper fade som är ren konst, snabb service och schysst personal. Perfekt läge i Åhléns också.",
    salonSlug: "ahlens-city",
    date: "2026-07-05",
    source: "BokaDirekt",
    verified: true,
    service: "taper-fade",
  },
  {
    id: "r11",
    author: "Viktor H.",
    location: "Kungsholmen",
    rating: 5,
    text: "Kom in en tisdag morgon och fick en av de bästa klippningarna jag haft. Barberaren tog sig tid att förstå ansiktsform och hårtyp innan sax och maskin ens plockades fram. Skarp finish och naturlig övergång.",
    salonSlug: "ahlens-city",
    date: "2026-07-08",
    source: "Google",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r13",
    author: "Ahmed B.",
    location: "Kista",
    rating: 5,
    text: "Bokade tid hos Neo och förstår nu varför han har så högt betyg. Skin fade som är ren precision – linjer som kunde vara ritade med linjal. Har hittat min barberare.",
    salonSlug: "ahlens-city",
    date: "2026-05-30",
    source: "BokaDirekt",
    verified: true,
    service: "taper-fade",
  },
  {
    id: "r14",
    author: "Tobias M.",
    location: "Östermalm",
    rating: 5,
    text: "Yannis är en mästare på skägget. Har ett ganska svårt skägg att forma men han visste direkt vad som passade min ansiktsform. Resultat: skarpast jag sett. Bokar igen nästa vecka.",
    salonSlug: "ahlens-city",
    date: "2026-06-10",
    source: "Google",
    verified: true,
    service: "skägg",
  },
  {
    id: "r15",
    author: "Kader S.",
    location: "Tensta",
    rating: 5,
    text: "Kom in för en taper fade och fick en klippning som imponerade på hela jobbet. Regla tog sig extra tid med nacken och sidorna – ingenting var lämnat till slumpen. Fem stjärnor är för lite.",
    salonSlug: "ahlens-city",
    date: "2026-06-22",
    source: "Google",
    verified: true,
    service: "taper-fade",
  },
  {
    id: "r16",
    author: "Linus F.",
    location: "Gamla Stan",
    rating: 5,
    text: "Drop-in på en måndag lunch och in på stolen inom tio minuter. Fick en herrklippning och kort skäggtrimning. Exakt det jag behövde innan ett viktigt möte. Prisvärt och proffsigt.",
    salonSlug: "ahlens-city",
    date: "2026-07-09",
    source: "BokaDirekt",
    verified: true,
    service: "hår-skägg",
  },
  {
    id: "r17",
    author: "Tariq A.",
    location: "Husby",
    rating: 5,
    text: "Sam klipper mig sen snart ett år. Bestämmer aldrig vad jag vill ha – han vet alltid bättre. Resultatet är alltid skarpt och håller hela månaden. Äkta hantverk.",
    salonSlug: "ahlens-city",
    date: "2026-07-14",
    source: "Google",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r18",
    author: "Johan K.",
    location: "Lidingö",
    rating: 5,
    text: "Tara är fantastisk. Mitt hår är lockigt och svårt att hantera men hon vet exakt hur det ska klippas för att ligga rätt. Fin service, schysst miljö och centralt läge. Kunde inte vara nöjdare.",
    salonSlug: "ahlens-city",
    date: "2026-07-17",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },

  // ─── Täby Centrum ────────────────────────────────────────────────────────
  {
    id: "r4",
    author: "Erik S.",
    location: "Täby",
    rating: 5,
    text: "Tagit min son hit sedan han var liten och nu tar han med sig sina kompisar. Personalen är tålmodig, barnvänlig och resultatet är alltid toppklass. Klart bäst i Täby.",
    salonSlug: "taby",
    date: "2026-05-22",
    source: "Google",
    verified: true,
  },
  {
    id: "r5",
    author: "Patrik N.",
    location: "Danderyd",
    rating: 5,
    text: "Tog drop-in en lördag, knappt någon väntetid. Barberaren tog sig tid att förstå min hårtextur innan han klippte – det märks att de är utbildade och brinner för det. Supernöjd.",
    salonSlug: "taby",
    date: "2026-06-14",
    source: "Google",
    verified: true,
  },
  {
    id: "r6",
    author: "Henrik A.",
    location: "Täby",
    rating: 5,
    text: "Bokade tid online, snabb och smidig process. Klippningen tog 30 minuter och resultatet var exakt det jag visat på bild. Proffsig miljö och schysst personal. Rekommenderas varmt.",
    salonSlug: "taby",
    date: "2026-07-02",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r19",
    author: "Simon B.",
    location: "Täby",
    rating: 5,
    text: "Har klippt mig hos William ett år nu och han är ovärderlig. Minns hur jag vill ha det, ger råd när jag är osäker och levererar ett resultat som håller. Bästa barbershop i norr.",
    salonSlug: "taby",
    date: "2026-06-08",
    source: "Google",
    verified: true,
  },
  {
    id: "r20",
    author: "David L.",
    location: "Vallentuna",
    rating: 5,
    text: "Tog med min son för barnklippning och fick själv en skin fade. Tony var tålmodig och snäll mot min son (7 år) och resultatet för oss båda var kanon. Rekommenderar starkt.",
    salonSlug: "taby",
    date: "2026-06-17",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r21",
    author: "Omar F.",
    location: "Täby",
    rating: 5,
    text: "Diana är suverän. Skarp fade, lyssnar på vad man vill och är alltid trevlig att prata med. Har provat flera ställen i Täby men inget i närheten av det här.",
    salonSlug: "taby",
    date: "2026-06-30",
    source: "Google",
    verified: true,
  },
  {
    id: "r22",
    author: "Mikael W.",
    location: "Täby",
    rating: 5,
    text: "Pringles är min go-to för skägget. Formade om hela profilen och gav mig tips om produkter som faktiskt fungerar. Investering i sig själv – klart värt pengarna.",
    salonSlug: "taby",
    date: "2026-07-03",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r23",
    author: "Christoffer J.",
    location: "Täby",
    rating: 5,
    text: "Kom på drop-in en söndag och väntetiden var minimal. Nemat klipper snabbt utan att kompromissa med kvaliteten. Lämnade med en av de bästa faderna jag haft.",
    salonSlug: "taby",
    date: "2026-07-07",
    source: "Google",
    verified: true,
  },
  {
    id: "r24",
    author: "Ali H.",
    location: "Danderyd",
    rating: 5,
    text: "Har svårt hår och har blivit missnöjd på många ställen förut. Här frågade barberaren rätt frågor från start och anpassade klippningen perfekt. Äntligen nöjd.",
    salonSlug: "taby",
    date: "2026-07-12",
    source: "Google",
    verified: true,
  },
  {
    id: "r25",
    author: "Gustav R.",
    location: "Täby",
    rating: 5,
    text: "Bokade hår och skägg-paketet och fick 60 minuters professionell behandling. Trevlig stämning, skickliga händer och ett resultat som höll hela veckan. Bokar redan nästa gång.",
    salonSlug: "taby",
    date: "2026-07-18",
    source: "BokaDirekt",
    verified: true,
  },

  // ─── Åkersberga ─────────────────────────────────────────────────────────
  {
    id: "r7",
    author: "Oscar B.",
    location: "Åkersberga",
    rating: 5,
    text: "Äntligen en riktigt bra barbershop i Åkersberga. Behövde inte åka in till stan längre. Skin fade som satt perfekt, trevlig personal och bra priser för kvaliteten man får.",
    salonSlug: "akersberga",
    date: "2026-05-11",
    source: "Google",
    verified: true,
  },
  {
    id: "r8",
    author: "Alexander M.",
    location: "Norrtälje",
    rating: 5,
    text: "Åker förbi Åkersberga regelbundet och stannar alltid in här. Konsekvent hög kvalitet varje gång, aldrig en besvikelse. Det är svårt att hitta en barbershop man kan lita på – den här är det.",
    salonSlug: "akersberga",
    date: "2026-06-25",
    source: "Google",
    verified: true,
  },
  {
    id: "r12",
    author: "Robin K.",
    location: "Österskär",
    rating: 5,
    text: "Klippt mig här flera gånger i sommar och det blir bättre för varje gång. Barberaren minns exakt hur jag vill ha det och är noggrann med nacke och konturer. Skönt att slippa åka in till stan.",
    salonSlug: "akersberga",
    date: "2026-07-06",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r26",
    author: "Mattias E.",
    location: "Åkersberga",
    rating: 5,
    text: "Diana är utan tvekan bäst i Åkersberga. Klippt mig hos henne i ett och ett halvt år och varje gång är bättre än förra. Vet precis vad jag vill ha och levererar alltid.",
    salonSlug: "akersberga",
    date: "2026-05-25",
    source: "Google",
    verified: true,
  },
  {
    id: "r27",
    author: "Kevin J.",
    location: "Vaxholm",
    rating: 5,
    text: "Åker hit från Vaxholm och det är värt varje kilometer. Sami ger en av de bästa skin faderna i regionen. Noggrann, pratar igenom vad man vill ha och håller exakt det han lovar.",
    salonSlug: "akersberga",
    date: "2026-06-03",
    source: "Google",
    verified: true,
  },
  {
    id: "r28",
    author: "Pontus H.",
    location: "Åkersberga",
    rating: 5,
    text: "Snabbaste bokningen jag gjort och ett av de bästa resultaten. Skin fade och skägg på under 50 minuter, och man märker att alla i salongen bryr sig om sitt jobb.",
    salonSlug: "akersberga",
    date: "2026-06-20",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r29",
    author: "Babak N.",
    location: "Norrtälje",
    rating: 5,
    text: "Åker förbi Åkersberga varje vecka och stannar alltid in när jag behöver klippa mig. Dia är otroligt noggrann med linjerna. Aldrig en besvikelse på tre år.",
    salonSlug: "akersberga",
    date: "2026-07-01",
    source: "Google",
    verified: true,
  },
  {
    id: "r30",
    author: "Jesper L.",
    location: "Åkersberga",
    rating: 5,
    text: "Tony klippte min 8-åring och han var fantastisk med honom. Tålmodig, rolig och resultatet var perfekt. Sonen vill inte klippa sig någon annanstans nu.",
    salonSlug: "akersberga",
    date: "2026-07-05",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r31",
    author: "Felix A.",
    location: "Täby",
    rating: 5,
    text: "Bästa barber i regionen, enkelt. 4,9 i betyg är välförtjänt – märks från första besöket att de håller en standard som de flesta salonger inte ens är i närheten av.",
    salonSlug: "akersberga",
    date: "2026-07-10",
    source: "Google",
    verified: true,
  },
  {
    id: "r32",
    author: "Rashid K.",
    location: "Åkersberga",
    rating: 5,
    text: "Tog hår och skägg-paketet och det var pengarna mer än värt. Barberaren formade om mitt skägg helt och gav det en profil jag inte visste att jag saknade. Jag är helomvänd.",
    salonSlug: "akersberga",
    date: "2026-07-15",
    source: "BokaDirekt",
    verified: true,
  },

  // ─── Arninge ────────────────────────────────────────────────────────────
  {
    id: "r9",
    author: "Sebastian K.",
    location: "Vallentuna",
    rating: 5,
    text: "Kombinerar alltid handling på ICA Maxi med ett besök här. Extremt smidigt och kvaliteten är konsekvent hög. Barberaren kom ihåg exakt hur jag brukar ha det – det kallas för service.",
    salonSlug: "arninge",
    date: "2026-06-04",
    source: "Google",
    verified: true,
  },
  {
    id: "r10",
    author: "Filip T.",
    location: "Täby",
    rating: 5,
    text: "Har testat alla salonger i norra Stockholm och Tailor's i Arninge är överlägset bäst. Ren, modern lokal, duktig personal och aldrig lång väntetid. Fem stjärnor utan tvekan.",
    salonSlug: "arninge",
    date: "2026-07-01",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r33",
    author: "Marcus A.",
    location: "Vallentuna",
    rating: 5,
    text: "William är en riktig all-around barberare. Klipper allt från klassiska herrklippningar till moderna fades och gör det med en säkerhet som imponerar. Min favorit sedan ett år.",
    salonSlug: "arninge",
    date: "2026-05-15",
    source: "Google",
    verified: true,
  },
  {
    id: "r34",
    author: "Emil K.",
    location: "Täby",
    rating: 5,
    text: "Kombinerar alltid handling med ett besök här. Smidigare än så kan det inte bli. Klippning och skäggtrimning på 55 minuter och man lämnar med en look som håller.",
    salonSlug: "arninge",
    date: "2026-05-29",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r35",
    author: "Noa B.",
    location: "Arninge",
    rating: 5,
    text: "Pringles gav mig den bästa skäggtrimningen jag haft. Visste exakt hur han ville forma det och varför – förklarade allt längs med. Det märks att han brinner för det.",
    salonSlug: "arninge",
    date: "2026-06-12",
    source: "Google",
    verified: true,
  },
  {
    id: "r36",
    author: "Samuel W.",
    location: "Vallentuna",
    rating: 5,
    text: "Taper fade av Tony – ren konst. Kom in med ett suddigt begrepp om vad jag ville och lämnade med exakt rätt look. Barberarna här lyssnar på ett sätt som är sällsynt.",
    salonSlug: "arninge",
    date: "2026-06-21",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r37",
    author: "Lukas F.",
    location: "Täby",
    rating: 5,
    text: "Har provat de flesta ställen i norra Stockholm. Inget håller måttet jämfört med Tailor's i Arninge. Konsekventa resultat, trevlig personal och aldrig en lång väntetid.",
    salonSlug: "arninge",
    date: "2026-07-02",
    source: "Google",
    verified: true,
  },
  {
    id: "r38",
    author: "Elias M.",
    location: "Norrtälje",
    rating: 5,
    text: "Adam är väldigt skicklig. Tydlig kommunikation, säker teknik och ett öga för vad som passar just mig. Kom in osäker på vilken stil jag ville ha, lämnade med något bättre än jag föreställt mig.",
    salonSlug: "arninge",
    date: "2026-07-08",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r39",
    author: "Pontus G.",
    location: "Arninge",
    rating: 5,
    text: "Drop-in på en fredag eftermiddag och fick plats direkt. Skin fade som satt felfritt och en skäggtrimning som lyfte hela looken. Centralt och smidigt läge vid ICA Maxi.",
    salonSlug: "arninge",
    date: "2026-07-13",
    source: "Google",
    verified: true,
  },
  {
    id: "r40",
    author: "Kevin O.",
    location: "Vallentuna",
    rating: 5,
    text: "Hela familjen klipps här nu. Vi tar med barnen och alla lämnar nöjda. Det är svårt att hitta en plats som levererar oavsett vem du är eller hur svårt ditt hår är.",
    salonSlug: "arninge",
    date: "2026-07-19",
    source: "BokaDirekt",
    verified: true,
  },
  {
    id: "r116",
    author: "Robin E.",
    location: "Stockholm",
    rating: 5,
    text: "Är väldigt nöjd efter ett besök hos Tim! Han är otroligt noggrann, lyssnar på vad man vill ha och har ett väldigt bra öga för detaljer. Samtidigt är han supertrevlig och får en att känna sig bekväm. Känns verkligen som att man är i trygga händer. Rekommenderar Tim varmt!",
    salonSlug: "ahlens-city",
    date: "2026-09-13",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r117",
    author: "Jacob K.",
    location: "Täby",
    rating: 5,
    text: "Har gått till Ali de senaste två åren och han är utan tvekan den bästa frisören jag någonsin gått till. Oerhört noggrann och vass på saxen (för referens brukar jag köra en låg taper), lyhörd och mån om att kunden får det man önskar och mer därtill. Samtidigt är han grym på att vägleda en dit och ge rekommendationer. Dessutom är han en skön och genomgod person! Hans recensioner talar sitt tydliga språk – för mig som numera bor en bit från Täby centrum är han definitivt värd en omväg. Klass rakt igenom!",
    salonSlug: "taby",
    date: "2026-09-12",
    source: "BokaDirekt",
    verified: true,
    service: "taper-fade",
  },
  {
    id: "r118",
    author: "Patrik H.",
    location: "Arninge",
    rating: 5,
    text: "Vahid, du är en stjärna! Som vanligt bokade jag den bästa frisören som finns! Håret blev jättefint och skägget snyggt anpassat efter faden. Har fått så många komplimanger om hur bra det blev. Grym är du!",
    salonSlug: "arninge",
    date: "2026-09-01",
    source: "BokaDirekt",
    verified: true,
    service: "hår-skägg",
  },
  {
    id: "r119",
    author: "Fredrik T.",
    location: "Stockholm",
    rating: 5,
    text: "Klipptes och fick skägg/mustasch trimmad av Neo. Mycket fin känsla för detalj och mån om att det skall bli som man vill ha det. 10/10 recommend!",
    salonSlug: "ahlens-city",
    date: "2026-09-14",
    source: "Google",
    verified: true,
    service: "hår-skägg",
  },
  {
    id: "r120",
    author: "Firouzeh B.",
    location: "Täby",
    rating: 5,
    text: "Mina två pojkar är alltid trasselsuddar som går in till Nick på Tailors barber och kommer ut som två nya, glada killar med coola frisyrer, båda två. Superfint och trevligt bemötande. Tack!",
    salonSlug: "taby",
    date: "2026-09-16",
    source: "Google",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r121",
    author: "Nils B.",
    location: "Arninge",
    rating: 5,
    text: "Alltid lika trevligt, alltid lika bra klippning. William är KUNG!!",
    salonSlug: "arninge",
    date: "2026-09-05",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r122",
    author: "Thomas C.",
    location: "Åkersberga",
    rating: 5,
    text: "Diana är supertrevlig och lyhörd. Hon är jätteduktig, klipper perfekt.",
    salonSlug: "akersberga",
    date: "2026-09-01",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r123",
    author: "Katarzyna I.",
    location: "Stockholm",
    rating: 5,
    text: "Neo är professionell och skicklig. Mycket bra kundbemötande. Sonen som är 12 år blev bemött med respekt, omtanke och genuint intresse. Klippningen blev perfekt.",
    salonSlug: "ahlens-city",
    date: "2026-10-01",
    source: "BokaDirekt",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r124",
    author: "Lina K.",
    location: "Åkersberga",
    rating: 5,
    text: "Min son var väldigt nöjd efter besöket hos Tony. Trevlig, vi gillade att han frågade om att få lite fria händer och gjorde en \"konsultation\" istället för att bara klippa efter önskemål, och hjälpte till att få bästa frisyren efter huvud osv. Återkommer!",
    salonSlug: "akersberga",
    date: "2026-10-04",
    source: "BokaDirekt",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r125",
    author: "Emerson O.",
    location: "Täby",
    rating: 5,
    text: "Finally I found a place where I can get the hair cut exactly how I want. I'm really happy with Nick, he's a really good barber and is always focused on providing good service.",
    salonSlug: "taby",
    date: "2026-10-05",
    source: "Google",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r126",
    author: "Fanny N.",
    location: "Åkersberga",
    rating: 5,
    text: "Bästa frisörerna, vi är alltid lika nöjda med upplevelsen 🙏🏼",
    salonSlug: "akersberga",
    date: "2026-10-10",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r127",
    author: "Per L.",
    location: "Åkersberga",
    rating: 5,
    text: "Bra klipp och vänligt bemötande :-)",
    salonSlug: "akersberga",
    date: "2026-10-08",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r128",
    author: "Gunnar M.",
    location: "Arninge",
    rating: 5,
    text: "Vahid är alltid trevlig och noggrann.",
    salonSlug: "arninge",
    date: "2026-10-09",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r129",
    author: "Anders T.",
    location: "Stockholm",
    rating: 5,
    text: "Neo tog hand om mig på bästa sätt! Jag var jättenöjd med klippningen och han var noggrann och proffsig! Jag kommer tillbaka!",
    salonSlug: "ahlens-city",
    date: "2026-10-16",
    source: "BokaDirekt",
    verified: true,
    service: "herrklippning",
  },
  {
    id: "r130",
    author: "Linda M.",
    location: "Täby",
    rating: 5,
    text: "Min son klipper sig där. Dom är snabba och effektiva men det blir alltid väldigt snyggt. Dom har bra hand om barn, pratar och skojar så att min son är avslappnad och bekväm. Vi har varit där många gånger och kommer att fortsätta gå dit.",
    salonSlug: "taby",
    date: "2026-10-18",
    source: "BokaDirekt",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r131",
    author: "Heléne O.",
    location: "Arninge",
    rating: 5,
    text: "Min son var hos Pringles och klippte sig för andra gången idag och han har inte varit lätt att få nöjd med sitt hår innan, men han är såå nöjd med sin frisyr nu. Och inte bara med själva frisyren utan även bemötandet. Självklart fem stjärnor och han är nu en stamkund.",
    salonSlug: "arninge",
    date: "2026-10-17",
    source: "BokaDirekt",
    verified: true,
    service: "barnklippning",
  },
  {
    id: "r132",
    author: "Andreas L.",
    location: "Åkersberga",
    rating: 5,
    text: "Mycket nöjd med resultatet gällande skägg och hår. Vaxning av näsa/öron gick på djupet istället för ytligt som vissa gör.",
    salonSlug: "akersberga",
    date: "2026-10-16",
    source: "BokaDirekt",
    verified: true,
    service: "hår-skägg",
  },
];

export const reviewsBySalon = reviews.reduce<Record<string, Review[]>>((acc, r) => {
  if (!acc[r.salonSlug]) acc[r.salonSlug] = [];
  acc[r.salonSlug].push(r);
  return acc;
}, {});

export const featuredReviews = reviews.filter((r) =>
  ["r1", "r2", "r11", "r19", "r7", "r9"].includes(r.id)
);

export function sortReviews(list: Review[]): Review[] {
  return [...list].sort((a, b) => b.date.localeCompare(a.date));
}

export const reviewsForSalon = (slug: SalonSlug): Review[] =>
  sortReviews(reviews.filter((r) => r.salonSlug === slug));

export const reviewsForSalonByService = (slug: SalonSlug, service: string): Review[] =>
  sortReviews(reviews.filter((r) => r.salonSlug === slug && r.service === service));
